var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-category",class:{act : _vm.activeIndex == _vm.index },on:{"click":function($event){return _vm.$emit('do-event')}}},[_vm._v(_vm._s(_vm.item.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }